import useWizard from 'src/hooks/useWizard'
import WizardContent from './WizardContent'

import * as styles from './WizardContent.scss'

const WizardPopupMenu = () => {
  const { dashboard } = useWizard()

  return (
    <div className={styles.Wizard}>
      <div className={styles.Content}>
        <WizardContent dashboards={dashboard as any} />
      </div>
    </div>
  )
}

export default WizardPopupMenu
